/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_EyebrowInputs */

const tr_pricing_eyebrow = /** @type {(inputs: Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FİYATLANDIRMA`)
};

const en_pricing_eyebrow = /** @type {(inputs: Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRICING`)
};

const de_pricing_eyebrow = /** @type {(inputs: Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PREISE`)
};

const ru_pricing_eyebrow = /** @type {(inputs: Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЦЕНЫ`)
};

/**
* | output |
* | --- |
* | "PRICING" |
*
* @param {Pricing_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_eyebrow = /** @type {((inputs?: Pricing_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_eyebrow(inputs)
	if (locale === "de") return de_pricing_eyebrow(inputs)
	if (locale === "ru") return ru_pricing_eyebrow(inputs)
	return tr_pricing_eyebrow(inputs)
});